export const BlogsSkeletonItem = () => {
  return (
    <div className="col-span-1 flex w-full flex-col items-end justify-start gap-6 lg:gap-8">
      <div className="relative aspect-video w-full bg-slate-100" />
      <div className="flex w-full flex-col items-start justify-start gap-1.5">
        <div className="h-[28px] w-[88%] bg-slate-100 lg:h-[39px]" />
        <div className="h-[28px] w-[92%] bg-slate-100 lg:h-[39px]" />
      </div>
      <div className="flex w-full flex-col items-start justify-start gap-1.5">
        <div className="h-[20px] w-full bg-slate-100 sm:h-[24px]" />
        <div className="h-[20px] w-[75%] bg-slate-100 sm:h-[24px]" />
        <div className="h-[20px] w-[90%] bg-slate-100 sm:h-[24px]" />
      </div>
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center justify-start gap-1.5">
          <div className="h-6 w-6 bg-slate-100" />
          <div className="h-6 w-24 bg-slate-100" />
        </div>
        <div className="h-12 w-[190px] bg-slate-100" />
      </div>
    </div>
  );
};
